import Vue from "vue";
import Pin from "vue-pin";

// install
Vue.use(Pin);
